/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UpdatePhoneNumberPayload } from 'api/actions/update-phone-number/update-phone-number-payload';
import { UpdatePhoneNumberPathParameters } from 'api/actions/update-phone-number/update-phone-number-path-parameters';
import { UpdatePhoneNumberResponse } from 'api/actions/update-phone-number/update-phone-number-response';

type UpdatePhoneNumberQueryParameters = Record<string, any>;

/**
 * The path of the UpdatePhoneNumber action.
 */
export const updatePhoneNumberActionPath = new SweetPath<keyof UpdatePhoneNumberPathParameters>('/user/phone-number', {
  path: '{param}',
});

/**
 * Creates a contextualized UpdatePhoneNumber actions.
 */
export default function createUpdatePhoneNumberAction(axios: AxiosInstance) {
  return function updatePhoneNumberAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: UpdatePhoneNumberQueryParameters;
    payload: UpdatePhoneNumberPayload;
  }) {
    const path = updatePhoneNumberActionPath.original;

    return axios.put<UpdatePhoneNumberResponse, UpdatePhoneNumberResponse, UpdatePhoneNumberPayload>(path, payload);
  };
}
